import { z } from 'zod';

import { schemaMappedPosition } from './MappedSchufaResponse';
import { schemaApplicantAttributionBoth } from '../utils/schema.utils';

export const schemaAddConsorsSchufaCreditToLead = z.object({
    gehoertZuAntragsteller: schemaApplicantAttributionBoth,
    // Consors sends 0 for absent numeric fields, so 0 counts as no value
    position: schemaMappedPosition.refine(
        ({ amount, rate, remainingAmount }) => Boolean(amount || rate || remainingAmount),
        { message: 'Position needs at least one of amount, rate or remainingAmount' },
    ),
});

export type SchemaAddConsorsSchufaCreditToLead = z.infer<typeof schemaAddConsorsSchufaCreditToLead>;
